import React, { useState } from 'react';
import { DialogActions } from '@mui/material';
import { StyledDialogContent } from '../styled/Dialog/StyledDialogContent';
import { isNullOrUndefined } from '../../utils/utils';
import useInvoiceDetailsDialog from '../../hooks/dialogs/useInvoiceDetailsDialog';
import InvoiceDetails from '../invoiceDetails/InvoiceDetails';
import { useTranslation } from 'react-i18next';
import InvoiceProducts from '../invoiceDetails/InvoiceProducts';
import SnackbarUtils from '../../utils/SnackbarUtils';
import useInvoiceProductsSWR from '../../hooks/invoices/useInvoiceProducts';
import { useNavigate } from 'react-router-dom';
import PrimaryBtn from '../shared/Buttons/PrimaryButton';
import ButtonOutlined from '../shared/Buttons/ButtonOutlined';
import useCart from '../../hooks/cart/useCart';
import InvoiceItemsAddedDialog from '../dialogs/InvoiceItemsAddedDialog';

const InvoiceDetailsWrapper = () => {
    const invoiceDetailsDialog = useInvoiceDetailsDialog();
    const navigate = useNavigate();
    const cart = useCart();
    const { t } = useTranslation('invoices', {
        keyPrefix: 'INVOICE_DETAILS',
    });
    const invoiceDetailsRow = invoiceDetailsDialog.dialogContent;

    const [cartConfirm, setCartConfirm] = useState(false);
    const [allProductsAdded, setAllProductsAdded] = useState<
        'all' | 'none' | 'partially'
    >('none');

    const { products, isLoading, isError, productNumber } =
        useInvoiceProductsSWR(invoiceDetailsRow.id);

    const setCartConfirmDialog = (resp) => {
        // check if products added successfully
        if (isNullOrUndefined(resp.cartLinesAdd.cart)) {
            const availableProducts = cart.getAvailableProducts(
                resp.cartLinesAdd.userErrors,
                products
            );
            if (availableProducts.length > 0) {
                cart.addInvoiceProductsToCart(availableProducts).then(
                    (result) => {
                        if (isNullOrUndefined(result.cartLinesAdd.cart)) {
                            //error
                            SnackbarUtils.error(
                                'Hiba történt a kosárba rakás közben.'
                            );
                        } else {
                            setAllProductsAdded('partially');
                            setCartConfirm(true);
                        }
                    }
                );
            } else {
                setAllProductsAdded('none');
                setCartConfirm(true);
            }
        } else {
            setAllProductsAdded('all');
            setCartConfirm(true);
        }
    };

    const addToCart = () => {
        cart.checkForShopifyProducts(products)
            .then((resp) => {
                cart.addInvoiceProductsToCart(resp)
                    .then((resp) => {
                        setCartConfirmDialog(resp);
                    })
                    .catch(() => {
                        setAllProductsAdded('none');
                        setCartConfirm(true);
                    });
            })
            .catch(() => {
                setAllProductsAdded('none');
                setCartConfirm(true);
            });
    };

    const handleGoToCart = () => {
        setCartConfirm(false);
        invoiceDetailsDialog.closeDialog();
        navigate('/cart');
    };

    return (
        <>
            <StyledDialogContent>
                <InvoiceDetails invoice={invoiceDetailsRow} />
                <InvoiceProducts
                    products={products}
                    isLoading={isLoading}
                    isError={isError}
                />
            </StyledDialogContent>
            <DialogActions>
                {!isLoading && (
                    <PrimaryBtn onClick={addToCart}>
                        {t('ADD_TO_CART')} ({productNumber})
                    </PrimaryBtn>
                )}
                <ButtonOutlined onClick={invoiceDetailsDialog.closeDialog}>
                    {t('CLOSE')}
                </ButtonOutlined>
            </DialogActions>
            <InvoiceItemsAddedDialog
                open={cartConfirm}
                productsAdded={allProductsAdded}
                handleClose={() => setCartConfirm(false)}
                handleGoToCart={handleGoToCart}
            />
        </>
    );
};

export default InvoiceDetailsWrapper;
